import { render, staticRenderFns } from "./overseaProduct.vue?vue&type=template&id=7b903456&scoped=true&"
import script from "./overseaProduct.vue?vue&type=script&lang=js&"
export * from "./overseaProduct.vue?vue&type=script&lang=js&"
import style0 from "./overseaProduct.vue?vue&type=style&index=0&id=7b903456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b903456",
  null
  
)

export default component.exports